module.exports = __webpack_public_path__ + "img/escaner.aa0cab5f.svg";